import { render, staticRenderFns } from "./RechargeRoom.vue?vue&type=template&id=55facb58&"
import script from "./RechargeRoom.vue?vue&type=script&lang=js&"
export * from "./RechargeRoom.vue?vue&type=script&lang=js&"
import style0 from "./RechargeRoom.vue?vue&type=style&index=0&id=55facb58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports